var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 75,
    viewBox: "0 0 111 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.5625 65.1232V58.0475H16V65.1183C16 70.2959 33.5885 74.4952 55.2812 74.4952C76.974 74.4952 94.5625 70.3007 94.5625 65.1232Z",
    fill: "#C3C4CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2837 67.4315C76.9781 67.4315 94.5649 63.2334 94.5649 58.0547C94.5649 52.876 76.9781 48.6779 55.2837 48.6779C33.5893 48.6779 16.0024 52.876 16.0024 58.0547C16.0024 63.2334 33.5893 67.4315 55.2837 67.4315Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2229 58.0475C20.2229 55.1711 33.8813 50.9912 55.2813 50.9912C65.2032 50.9912 74.4766 51.8966 81.376 53.5448C86.9057 54.8652 90.3299 56.5911 90.3299 58.0475C90.3299 60.9263 76.6715 65.1062 55.2692 65.1062C45.3472 65.1062 36.0762 64.1984 29.1769 62.5527C23.6569 61.237 20.2229 59.5039 20.2229 58.0475Z",
    fill: "#C3C4CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8314 67.4315V74.4611L53.3646 74.4878V67.4315H58.8314Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0346 67.0553V74.4611L47.3 74.381V67.0553H50.0346Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2864 64.3439V71.9342C26.7867 71.6686 25.3124 71.2748 23.8796 70.7569V63.2686L28.2864 64.3439Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8721 64.1473V72.024C81.8721 72.024 84.793 71.371 87.5107 70.4851V63.1885L81.8721 64.1473Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5625 56.6275V49.5518H16V56.6226C16 61.8001 33.5885 65.9994 55.2812 65.9994C76.974 65.9994 94.5625 61.805 94.5625 56.6275Z",
    fill: "#C3C4CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2837 58.9359C76.9781 58.9359 94.5649 54.7378 94.5649 49.5591C94.5649 44.3804 76.9781 40.1823 55.2837 40.1823C33.5893 40.1823 16.0024 44.3804 16.0024 49.5591C16.0024 54.7378 33.5893 58.9359 55.2837 58.9359Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2229 49.5518C20.2229 46.6754 33.8813 42.4955 55.2813 42.4955C65.2032 42.4955 74.4766 43.4009 81.376 45.049C86.9057 46.3695 90.3299 48.0954 90.3299 49.5518C90.3299 52.4306 76.6715 56.6105 55.2692 56.6105C45.3472 56.6105 36.0762 55.7027 29.1769 54.0569C23.6569 52.7413 20.2229 51.0082 20.2229 49.5518Z",
    fill: "#C3C4CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6961 58.0547V65.963L57.2294 65.9921V58.0547H62.6961Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0887 58.0547V66.2761L50.3566 66.1887V58.0547H53.0887Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4885 56.6032V64.8562C28.9836 64.5658 27.5085 64.1376 26.0817 63.5769V55.4259L30.4885 56.6032Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8735 54.8143V63.1886C83.8735 63.1886 86.7921 62.4943 89.5097 61.5525V53.785L83.8735 54.8143Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4769 51.0518L43.3508 48.4715L61.1183 47.4666L46.8598 46.0296L49.6863 44.3135L71.0427 46.9229L67.9863 49.2992L38.4769 51.0518Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8341 45.1729L49.0304 48.258L52.2514 48.6755L57.0575 45.5904L53.8341 45.1729Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9863 49.2993L68.3638 51.4669L39.8708 53.3918L38.4769 51.0519L67.9863 49.2993Z",
    fill: "#C6830C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0426 46.923L67.9862 49.2993L68.3637 51.467L71.5654 48.9619L71.0426 46.923Z",
    fill: "#C6830C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8597 46.0297L47.4672 47.554L49.9234 47.6827L51.7215 46.5273L46.8597 46.0297Z",
    fill: "#C6830C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0804 46.8574L53.4203 47.9036L61.1183 47.4667L55.0804 46.8574Z",
    fill: "#C6830C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6299 49.2338C19.6299 46.3549 33.2883 42.175 54.6907 42.175C64.6126 42.175 73.8836 43.0829 80.7854 44.7286C86.3151 46.0491 89.7394 47.7749 89.7394 49.2338C89.7394 52.1102 76.081 56.2901 54.6786 56.2901C44.7566 56.2901 35.4856 55.3822 28.5838 53.7365C23.0663 52.416 19.6299 50.6902 19.6299 49.2338Z",
    fill: "#C3C4CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5625 47.9788V40.9104H16V47.9788C16 53.1588 33.5885 57.3557 55.2812 57.3557C76.974 57.3557 94.5625 53.1588 94.5625 47.9788Z",
    fill: "#C3C4CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2837 50.2872C76.9781 50.2872 94.5649 46.0891 94.5649 40.9104C94.5649 35.7317 76.9781 31.5336 55.2837 31.5336C33.5893 31.5336 16.0024 35.7317 16.0024 40.9104C16.0024 46.0891 33.5893 50.2872 55.2837 50.2872Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2229 40.9104C20.2229 38.0316 33.8813 33.8517 55.2813 33.8517C65.2032 33.8517 74.4766 34.7595 81.376 36.4053C86.9057 37.7257 90.3299 39.4516 90.3299 40.9104C90.3299 43.7868 76.6715 47.9667 55.2692 47.9667C45.3472 47.9667 36.0762 47.0613 29.1769 45.4131C23.6569 44.0927 20.2229 42.3668 20.2229 40.9104Z",
    fill: "#C3C4CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8314 50.2872V57.3168L53.3646 57.3459V50.2872H58.8314Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0346 49.911V57.3168L47.3 57.2367V49.911H50.0346Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2864 47.1996V54.7899C26.7867 54.5244 25.3124 54.1305 23.8796 53.6126V46.1243L28.2864 47.1996Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8721 47.0054V54.8919C81.8721 54.8919 84.793 54.2389 87.5107 53.353V46.0709L81.8721 47.0054Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5625 39.4832V32.4148H16V39.4832C16 44.6632 33.5885 48.86 55.2812 48.86C76.974 48.86 94.5625 44.6632 94.5625 39.4832Z",
    fill: "#C3C4CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2837 41.7915C76.9781 41.7915 94.5649 37.5934 94.5649 32.4147C94.5649 27.236 76.9781 23.0378 55.2837 23.0378C33.5893 23.0378 16.0024 27.236 16.0024 32.4147C16.0024 37.5934 33.5893 41.7915 55.2837 41.7915Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2229 32.4147C20.2229 29.5359 33.8813 25.356 55.2813 25.356C65.2032 25.356 74.4766 26.2638 81.376 27.9095C86.9057 29.23 90.3299 30.9559 90.3299 32.4147C90.3299 35.2911 76.6715 39.471 55.2692 39.471C45.3472 39.471 36.0762 38.5656 29.1769 36.9174C23.6569 35.5969 20.2229 33.8711 20.2229 32.4147Z",
    fill: "#C3C4CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6961 40.9104V48.8187L57.2294 48.8502V40.9104H62.6961Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0887 40.9104V49.1342L50.3566 49.0444V40.9104H53.0887Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4885 39.4589V47.7119C28.9836 47.4215 27.5085 46.9933 26.0817 46.4327V38.2889L30.4885 39.4589Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8735 37.6699V46.0467C83.8735 46.0467 86.7921 45.3525 89.5097 44.4082V36.6407L83.8735 37.6699Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4769 33.9099L43.3508 31.3297L61.1183 30.3248L46.8598 28.8853L49.6863 27.1716L71.0427 29.781L67.9863 32.155L38.4769 33.9099Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8341 28.0286L49.0304 31.1137L52.2514 31.5312L57.0575 28.4461L53.8341 28.0286Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9863 32.155L68.3638 34.3226L39.8708 36.2475L38.4769 33.91L67.9863 32.155Z",
    fill: "#C6830C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0426 29.781L67.9862 32.155L68.3637 34.3226L71.5654 31.8175L71.0426 29.781Z",
    fill: "#C6830C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8597 28.8854L47.4672 30.4098L49.9234 30.5408L51.7215 29.3854L46.8597 28.8854Z",
    fill: "#C6830C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0804 29.7156L53.4203 30.7593L61.1183 30.3248L55.0804 29.7156Z",
    fill: "#C6830C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6299 32.0895C19.6299 29.2107 33.2883 25.0308 54.6907 25.0308C64.6126 25.0308 73.8836 25.9386 80.7854 27.5843C86.3151 28.9048 89.7394 30.6307 89.7394 32.0895C89.7394 34.9659 76.081 39.1458 54.6786 39.1458C44.7566 39.1458 35.4856 38.2404 28.5838 36.5922C23.0663 35.2717 19.6299 33.5459 19.6299 32.0895Z",
    fill: "#C3C4CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5625 30.8199V23.749H16V30.8199C16 35.9974 33.5885 40.1967 55.2812 40.1967C76.974 40.1967 94.5625 35.9974 94.5625 30.8199Z",
    fill: "#C3C4CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2837 33.1284C76.9781 33.1284 94.5649 28.9303 94.5649 23.7516C94.5649 18.5729 76.9781 14.3748 55.2837 14.3748C33.5893 14.3748 16.0024 18.5729 16.0024 23.7516C16.0024 28.9303 33.5893 33.1284 55.2837 33.1284Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2229 23.7491C20.2229 20.8727 33.8813 16.6929 55.2813 16.6929C65.2032 16.6929 74.4766 17.5983 81.376 19.2464C86.9057 20.5669 90.3299 22.2927 90.3299 23.7491C90.3299 26.628 76.6715 30.8079 55.2692 30.8079C45.3472 30.8079 36.0762 29.9 29.1769 28.2543C23.6569 26.9338 20.2229 25.208 20.2229 23.7491Z",
    fill: "#C3C4CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8314 33.1283V40.1579L53.3646 40.1846V33.1283H58.8314Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0346 32.7521V40.1579L47.3 40.0778V32.7521H50.0346Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2864 30.0408V37.6311C26.7867 37.3656 25.3124 36.9717 23.8796 36.4538V28.9655L28.2864 30.0408Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8721 29.8442V37.7209C81.8721 37.7209 84.793 37.068 87.5107 36.182V28.8854L81.8721 29.8442Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5625 22.3243V15.2534H16V22.3243C16 27.5018 33.5885 31.7011 55.2812 31.7011C76.974 31.7011 94.5625 27.5018 94.5625 22.3243Z",
    fill: "#C3C4CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2837 24.6327C76.9781 24.6327 94.5649 20.4345 94.5649 15.2559C94.5649 10.0772 76.9781 5.87903 55.2837 5.87903C33.5893 5.87903 16.0024 10.0772 16.0024 15.2559C16.0024 20.4345 33.5893 24.6327 55.2837 24.6327Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2229 15.2534C20.2229 12.377 33.8813 8.19714 55.2813 8.19714C65.2032 8.19714 74.4766 9.10255 81.376 10.7507C86.9057 12.0712 90.3299 13.797 90.3299 15.2534C90.3299 18.1322 76.6715 22.3122 55.2692 22.3122C45.3472 22.3122 36.0762 21.4043 29.1769 19.7586C23.6569 18.4381 20.2229 16.7123 20.2229 15.2534Z",
    fill: "#C3C4CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6961 23.7491V31.6599L57.2294 31.6914V23.7491H62.6961Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0887 23.7491V31.973L50.3566 31.8856V23.7491H53.0887Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4885 22.3001V30.553C28.9834 30.2624 27.5083 29.8334 26.0817 29.2714V21.1228L30.4885 22.3001Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8735 20.511V28.8853C83.8735 28.8853 86.7921 28.1911 89.5097 27.2493V19.4818L83.8735 20.511Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4769 16.7486L43.3508 14.1683L61.1183 13.1634L46.8598 11.7264L49.6863 10.0103L71.0427 12.6196L67.9863 14.996L38.4769 16.7486Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8341 10.8696L49.0304 13.9548L52.2514 14.3723L57.0575 11.2871L53.8341 10.8696Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9863 14.9961L68.3638 17.1637L39.8708 19.0886L38.4769 16.7486L67.9863 14.9961Z",
    fill: "#C6830C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0426 12.6198L67.9862 14.9961L68.3637 17.1637L71.5654 14.6587L71.0426 12.6198Z",
    fill: "#C6830C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8597 11.7264L47.4672 13.2508L49.9234 13.3795L51.7215 12.224L46.8597 11.7264Z",
    fill: "#C6830C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0804 12.5542L53.4203 13.6004L61.1183 13.1635L55.0804 12.5542Z",
    fill: "#C6830C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6299 14.9281C19.6299 12.0517 33.2883 7.87183 54.6907 7.87183C64.6126 7.87183 73.8836 8.77966 80.7854 10.4254C86.3151 11.7459 89.7394 13.4717 89.7394 14.9281C89.7394 17.8069 76.081 21.9868 54.6786 21.9868C44.7566 21.9868 35.4856 21.079 28.5838 19.4333C23.0663 18.1128 19.6299 16.3869 19.6299 14.9281Z",
    fill: "#C3C4CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9315 50.0615L33.1852 48.9595L27.9315 47.8527C26.6092 47.5768 25.396 46.9196 24.4408 45.962C23.4856 45.0043 22.8299 43.7877 22.5542 42.4615L21.458 37.1893L20.3617 42.4615C20.0845 43.7886 19.4271 45.0056 18.4702 45.9633C17.5133 46.921 16.2985 47.5776 14.9748 47.8527L9.71863 48.9523L14.9748 50.0543C16.2989 50.3328 17.5135 50.9921 18.4701 51.9516C19.4267 52.9112 20.084 54.1294 20.3617 55.4575L21.458 60.7176L22.5542 55.4575C22.8305 54.1311 23.4863 52.9143 24.4413 51.9559C25.3963 50.9975 26.6092 50.3392 27.9315 50.0615Z",
    fill: "#63657F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6309 37.835L13.6922 37.1966L10.6309 36.5583C9.85704 36.397 9.14699 36.0124 8.58808 35.4518C8.02917 34.8912 7.64575 34.179 7.48495 33.4027L6.85817 30.3297L6.22171 33.4003C6.06091 34.1765 5.67749 34.8887 5.11858 35.4494C4.55967 36.01 3.84962 36.3945 3.07573 36.5558L0.00476074 37.1942L3.07573 37.8326C3.84949 37.9942 4.55938 38.3789 5.11824 38.9394C5.6771 39.5 6.06062 40.212 6.22171 40.9882L6.85817 44.0587L7.5043 40.9882C7.66441 40.215 8.04524 39.5053 8.60039 38.9455C9.15553 38.3856 9.86104 37.9998 10.6309 37.835Z",
    fill: "#63657F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.326 8.04413L97.2449 7.40088L100.326 6.75519C101.099 6.59275 101.808 6.20781 102.367 5.64739C102.926 5.08698 103.31 4.37537 103.471 3.59965L104.115 0.509644L104.757 3.59965C104.92 4.37485 105.304 5.08583 105.862 5.64606C106.421 6.20628 107.13 6.59161 107.903 6.75519L110.983 7.40088L107.903 8.04413C107.13 8.20942 106.423 8.59534 105.864 9.15528C105.306 9.71522 104.921 10.4252 104.757 11.1997L104.115 14.2848L103.471 11.1997C103.308 10.4245 102.924 9.71352 102.366 9.15329C101.807 8.59307 101.098 8.20772 100.326 8.04413Z",
    fill: "#63657F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111,
    height: 74,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.979b0289.svg";
export { ForwardRef as ReactComponent };